import i18next from 'i18next';
import { constants, verifiers } from '@yola/subscription-manager-js';
import { PER_MONTH } from '../../common/constants/terms';
import getFormattedSubscriptionPrice from '../../products/accessors/get-formatted-subscription-price';

const { CANCELED } = constants.SubscriptionStatus;

const getCancelPlans = (userSubscriptions, isHostingSubscription, isFreeTrialUpsellEnabled) =>
  userSubscriptions
    .filter(
      ({ isEcommerce, subscriptionMeta }) =>
        subscriptionMeta.status !== CANCELED && (isHostingSubscription || isEcommerce)
    )
    .map(({ isEcommerce, subscriptionMeta, name: subscriptionName }) => {
      const { type, term, id } = subscriptionMeta;
      const price = getFormattedSubscriptionPrice(type, term);
      const isTrial =
        isFreeTrialUpsellEnabled && verifiers.isActiveTrialSubscription(subscriptionMeta);

      return {
        id,
        name: `${
          isEcommerce ? i18next.t('Online store') : i18next.t('Hosting plan')
        }: ${subscriptionName}${isTrial ? ` (${i18next.t('14-day trial')})` : ''}`,
        renew: term === PER_MONTH ? i18next.t('Renews monthly') : i18next.t('Renews annually'),
        price,
        isTrial,
        notification:
          isHostingSubscription && isEcommerce
            ? i18next.t(
                'Note that cancelling your account will also cancel your online store. You won’t be able to sell your products on our platform anymore.'
              )
            : '',
      };
    });

export default getCancelPlans;
